import { render } from "./DragAndDrop.vue?vue&type=template&id=e2de1604&scoped=true"
import script from "./DragAndDrop.vue?vue&type=script&lang=js"
export * from "./DragAndDrop.vue?vue&type=script&lang=js"

import "./DragAndDrop.vue?vue&type=style&index=0&id=e2de1604&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src299072838/src/goku/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2de1604"]])

export default __exports__